import React from 'react';
import { Col, Radio } from 'antd';
import { useFormikContext } from 'formik';
import _get from 'lodash/get';

import { useGenderList } from 'api/mappings';
import { FlexContainer } from 'components/Layout/common';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';
import i18n from 'utils/i18n';

const Gender: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { data: genderList = [] } = useGenderList();

  const { t } = useMultiLanguageTranslation();

  return (
    <FlexContainer>
      <Radio.Group
        name="gender"
        value={_get(values, 'filters.gender[0].criteria[0].value')}
        onChange={e => {
          setFieldValue('filters.gender[0].criteria[0].value', e.target.value);
        }}
      >
        {genderList?.map(gender => (
          <Col key={gender.id} xs={{ span: 10, offset: 1 }}>
            <Radio key={gender.id} value={gender.id}>
              {i18n.exists(
                `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.GenderFilter.${gender.name}`
              )
                ? t(
                    `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.GenderFilter.${gender.name}`
                  )
                : gender.name}
            </Radio>
          </Col>
        ))}
      </Radio.Group>
    </FlexContainer>
  );
};

export default Gender;
